<template>
  <div id="pageDashboard">
    <v-progress-linear
      v-if="pageLoading"
      class="mt-1"
      :indeterminate="true"
    ></v-progress-linear>
    <v-container
      :class="{ 'px-0 pt-1': $vuetify.breakpoint.xs }"
      v-else
      fluid
      grid-list-md
    >
      <v-layout row wrap class="ma-0 mb-8">
        <v-flex xs12 sm6 md6 lg3>
          <material-stats-card
            elevation="0"
            color="orange"
            icon="tv"
            :title="lang.outstanding_invoices"
            :value1="outstandingInvoicesCount"
            :value2="outstandingInvoices"
            :sub-text="lang.open_billing"
            subTextColor="primary"
            @cardAction="openBilling"
            sub-icon="fa-light fa-file-invoice-dollar"
            :sub-icon-loading="outstandingInvoicesLoading"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg3>
          <material-stats-card
            elevation="0"
            color="indigo"
            icon="tv"
            :title="lang.users"
            :value1="allusers.length"
            :sub-text="lang.refresh"
            subTextColor="orange"
            @cardAction="refreshUsers"
            sub-icon="fa-light fa-arrows-rotate"
            :sub-icon-loading="refreshingUsers"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg3>
          <material-stats-card
            elevation="0"
            color="blue"
            icon="tv"
            :title="lang.players"
            :value1="allPlayers.count"
            :sub-text="lang.refresh"
            subTextColor="orange"
            @cardAction="refreshPlayers"
            sub-icon="fa-light fa-arrows-rotate"
            :sub-icon-loading="refreshingPlayers"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg3>
          <material-stats-card
            elevation="0"
            color="green"
            icon="tv"
            :title="lang.online_players"
            :value1="allPlayers.online"
            :sub-text="lang.refresh"
            subTextColor="orange"
            @cardAction="refreshPlayers"
            sub-icon="fa-light fa-arrows-rotate"
            :sub-icon-loading="refreshingPlayers"
          />
        </v-flex>

        <v-flex xs12 sm6 md6 lg3>
          <material-stats-card
            elevation="0"
            color="red"
            icon="tv"
            :title="lang.offline_players"
            :value1="allPlayers.offline"
            :sub-text="lang.refresh"
            subTextColor="orange"
            @cardAction="refreshPlayers"
            sub-icon="fa-light fa-arrows-rotate"
            :sub-icon-loading="refreshingPlayers"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg3>
          <material-stats-card
            elevation="0"
            color="purple"
            icon="card"
            :title="lang.active_licences"
            :value1="allPlayers.paid"
            :sub-text="lang.refresh"
            subTextColor="orange"
            @cardAction="refreshPlayers"
            sub-icon="fa-light fa-arrows-rotate"
            :sub-icon-loading="refreshingPlayers"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg3>
          <material-stats-card
            elevation="0"
            color="blue-grey darken-2"
            icon="card"
            :title="lang.expired_licences"
            :value1="allPlayers.expired"
            :sub-text="lang.refresh"
            subTextColor="orange"
            @cardAction="refreshPlayers"
            sub-icon="fa-light fa-arrows-rotate"
            :sub-icon-loading="refreshingPlayers"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import materialStatsCard from "@/components/material/StatsCard";
import materialCard from "@/components/material/Card";
const dashboards = require("./dashboard.js").dashboards;
export default {
  data() {
    return {
      pageLoading: true,
      allusers: [],
      outstandingInvoices: "",
      outstandingInvoicesLoading: false,
      outstandingInvoicesCount: 0,
      allPlayers: {
        count: 0,
        offline: 0,
        online: 0,
      },
      refreshingPlayers: false,
      refreshingUsers: false,
    };
  },
  components: {
    materialCard,
    materialStatsCard,
  },
  computed: {
    ...mapState(["loading", "lang", "fb", "adminUser"]),
  },
  methods: {
    refreshUsers() {
      dashboards.getUsers();
    },
    refreshPlayers() {
      dashboards.getAllPlayers();
    },
    openBilling() {
      this.billingLoading = true;
      var me = this;
      var callback = function(res) {
        me.billingLoading = false;
        if (res.status && res.data && res.data.url) {
          window.open(res.data.url, "_blank");
        } else {
          me.$toastr("error", me.lang.error);
        }
      };
      this.adminUser.openBilling(callback);
    },
    async refreshInvoices() {
      this.outstandingInvoicesLoading = true;
      const invoices = await dashboards.getInvoices();
      let amount = 0;
      let currency = "";
      this.outstandingInvoicesCount = 0;
      for (const inv of invoices) {
        if (inv.Status == "open") {
          this.outstandingInvoicesCount++;
          console.log("inv.DueAmount", inv);
          amount = amount + inv.AmountRemaining / 100;
          currency = inv.Currency;
        }
      }
      this.outstandingInvoices = `${currency.toUpperCase()} ${new Intl.NumberFormat().format(
        amount
      )}`;
      this.outstandingInvoicesLoading = false;
    },
  },
  mounted() {
    var breadcrumb = {};
    breadcrumb.title = this.lang.dashboard;
    this.$store.commit("breadcrumb", breadcrumb);
    dashboards.init(this);
    this.refreshInvoices();
  },
};
</script>
<style>
.dashboard_title {
  max-width: 60% !important;
}
.container {
  padding: 16px;
}

#displays_details .v-window__container,
#displays_details .v-window {
  height: 100%;
}
</style>
